import { AppActionTypes } from 'types/store/actions/constants';
import { AppActions } from 'types/store/reducers/app';

export const setError = (error?: string): AppActions => ({
  type: AppActionTypes.SET_ERROR,
  payload: error,
});

export const cleanError = (): AppActions => ({
  type: AppActionTypes.CLEAN_ERROR,
});
